import ProductForm from "../components/ProductEditForm";
export default function ProductEdit(props) {
  return (
    <ProductForm action="edit" />
  );
}
